import React from 'react';
import { SVGBabyNames } from '../../../../Svg/BabyNamesPage';
import { SearchInput } from './styled';

export default function SearchField(props) {
  const { setLetter } = props;
  return (
    <SearchInput>
      <SVGBabyNames id="searchblacknew" />

      <input
        type="text"
        name=""
        id=""
        placeholder="Type starting letter here"
        onChange={(e) => {
          setLetter.current = e.target.value;
        }}
      />
    </SearchInput>
  );
}
